@if (timeLeftString(); as timeLeft) {
  <div class="mb-3 d-flex">
    <div class="bg-danger text-light rounded-10 px-2 py-1">
      <i class="fa fa-warning"></i>
      Warning
    </div>
  </div>
  <div class="center h-100 text-center caution">You will be logged out in {{ timeLeft }}</div>
}
